import React from "react";
import {Route, Routes} from "react-router-dom";
import {WebGLDrawPage} from "@/pages/webgl-draw";

export const WebGLDrawRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<WebGLDrawPage />} />
        </Routes>
    );
};
